import { motion } from "framer-motion";

export default function Shopify() {
  return (
    <div className="section">

      {/* HERO */}
      <div className="container" style={{ textAlign: "center" }}>
        <motion.h1
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          className="section-title"
        >
          Enterprise Shopify Store Development & Growth Systems
        </motion.h1>

        <p style={{ maxWidth: "850px", margin: "20px auto" }}>
          We build high-performance Shopify stores designed to increase conversions,
          maximize revenue, and scale your eCommerce business from day one.
        </p>

      
      </div>

      {/* TRUST */}
      <div className="container" style={{ textAlign: "center", marginTop: "60px" }}>
        <div className="process">
          <div>Conversion-Focused Design</div>
          <div>Custom Theme Development</div>
          <div>Revenue Optimization Systems</div>
          <div>Scalable eCommerce Architecture</div>
        </div>
      </div>

      {/* STORE SETUP */}
      <div className="container" style={{ marginTop: "100px" }}>
        <h2 className="section-title">Complete Store Setup</h2>

        <div className="services">
          <div className="service-card">
            <h3>Full Store Build</h3>
            <p>Home, product, collection, about, and contact pages fully designed.</p>
          </div>

          <div className="service-card">
            <h3>Custom Theme Development</h3>
            <p>Fully customized Shopify themes tailored to your brand.</p>
          </div>

          <div className="service-card">
            <h3>Product & Collection Setup</h3>
            <p>Optimized product structure for better browsing and sales.</p>
          </div>

          <div className="service-card">
            <h3>Mobile-First Design</h3>
            <p>Responsive UI optimized for mobile conversions.</p>
          </div>
        </div>
      </div>

      {/* CONVERSION */}
      <div className="container" style={{ marginTop: "100px" }}>
        <h2 className="section-title">Conversion Optimization (CRO)</h2>

        <div className="services">
          <div className="service-card">
            <h3>High-Converting Product Pages</h3>
            <p>Trust badges, reviews, urgency, and optimized layouts.</p>
          </div>

          <div className="service-card">
            <h3>Cart & Checkout Optimization</h3>
            <p>Reduced friction and abandonment with optimized flows.</p>
          </div>

          <div className="service-card">
            <h3>Upsells & Bundles</h3>
            <p>Increase average order value with smart upsell strategies.</p>
          </div>

          <div className="service-card">
            <h3>Performance Optimization</h3>
            <p>Fast-loading stores for better UX and SEO.</p>
          </div>
        </div>
      </div>

      {/* MARKETING */}
      <div className="container" style={{ marginTop: "100px" }}>
        <h2 className="section-title">Marketing & Analytics</h2>

        <div className="services">
         

          <div className="service-card">
            <h3>Email & SMS Integration</h3>
            <p>Customer retention through automated campaigns.</p>
          </div>

         

          <div className="service-card">
            <h3>SEO Optimization</h3>
            <p>On-page SEO and structure for search visibility.</p>
          </div>
        </div>
      </div>

      {/* APPS */}
      <div className="container" style={{ marginTop: "100px" }}>
        <h2 className="section-title">Apps & Integrations</h2>

        <div className="services">
          <div className="service-card">
            <h3>Shopify Apps Setup</h3>
            <p>Upsell, reviews, subscriptions, and automation apps.</p>
          </div>

          <div className="service-card">
            <h3>Payment Gateway Integration</h3>
            <p>Secure and reliable payment processing systems.</p>
          </div>

          <div className="service-card">
            <h3>Shipping  Setup</h3>
            <p>Delivery zones and rates</p>
          </div>

        
        </div>
      </div>

      {/* GLOBAL */}
      <div className="container" style={{ marginTop: "100px" }}>
        <h2 className="section-title">Global & Scalable Setup</h2>

        <div className="services">
          <div className="service-card">
            <h3>Multi-Currency</h3>
            <p>Sell internationally with localized pricing.</p>
          </div>

          <div className="service-card">
            <h3>Multi-Language</h3>
            <p>Reach global customers with localized content.</p>
          </div>

          <div className="service-card">
            <h3>Scalable Architecture</h3>
            <p>Built for growth and high traffic.</p>
          </div>

          <div className="service-card">
            <h3>Post-Purchase Experience</h3>
            <p>Upsells, tracking, and retention after checkout.</p>
          </div>
        </div>
      </div>

      {/* PROCESS */}
      <div className="container" style={{ marginTop: "100px" }}>
        <h2 className="section-title">Our Process</h2>

        <div className="process">
          <div>1. Strategy & Planning</div>
          <div>2. Design & Development</div>
          <div>3. Optimization</div>
          <div>4. Launch</div>
          <div>5. Growth & Scaling</div>
        </div>
      </div>

      {/* DELIVERABLES */}
      <div className="container" style={{ marginTop: "100px", textAlign: "center" }}>
        <h2 className="section-title">What You Get</h2>

        <div className="process">
          <div>✔ Fully Built Shopify Store</div>
          <div>✔ Conversion Optimized UI</div>
          <div>✔ Payment & Shipping Setup</div>
          <div>✔ Marketing & Analytics</div>
          <div>✔ Ongoing Support</div>
        </div>
      </div>

      {/* CASE STUDY */}
      <div className="container" style={{ marginTop: "100px" }}>
        <h2 className="section-title">Case Study</h2>

        <div className="service-card">
          <h3>Feoric (Ecommerce Brand)</h3>
          <p><strong>Problem:</strong> Low conversion rate (0.8%)</p>
          <p><strong>Solution:</strong> Redesigned UX + Upsell system</p>
          <p><strong>Result:</strong> 2.7% conversion • 3.2X revenue growth</p>
        </div>
      </div>

      {/* CTA */}
      <div className="container" style={{ textAlign: "center", marginTop: "100px" }}>
        <h2>Build a Shopify Store That Actually Makes Money</h2>
        <p>
          From store setup to revenue optimization — we handle everything end-to-end.
        </p>

        <a href="/contact" className="btn-primary">
          Start Your Project
        </a>
      </div>

    </div>
  );
}